import React from "react";
import { FiAlertTriangle, FiRefreshCw, FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";
import logo from "./assets/hallef-logo-cropped.png";
import "./error-page.css";

export default function ErrorPage() {
  return (
    <main className="error-page" aria-labelledby="error-page-title">
      <Link to="/" aria-label="Hallef Technologies home">
        <img className="error-page-logo" src={logo} alt="Hallef Technologies" />
      </Link>
      <section className="error-page-card">
        <div className="error-page-icon" aria-hidden="true"><FiAlertTriangle /></div>
        <p className="error-page-eyebrow">SOMETHING WENT WRONG</p>
        <h1 id="error-page-title">Oops! An error occurred</h1>
        <p className="error-page-description">
          We couldn't load this page. Please try again, or return to the home page to continue.
        </p>
        <div className="error-page-actions">
          <button className="error-page-retry" type="button" onClick={() => window.location.reload()}>
            <FiRefreshCw aria-hidden="true" /> Try Again
          </button>
          <Link className="error-page-home" to="/">
            <FiArrowLeft aria-hidden="true" /> Back to Home
          </Link>
        </div>
      </section>
      <p className="error-page-footer">Hallef Technologies</p>
    </main>
  );
}
